import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const Hoken = props => {
  return <Dropdown.Static kubunKey='hoken' {...props} />
}
